<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="cols"
        :form-context="formContext"
        icon="inticon-autoclaim_document"
        title="Beauftragungsdokumente">
        <csp-desktop-firm-configurable-documents-form :context-id="contextId" :context-type="contextType"/>
    </csp-desktop-info-card>
</template>

<script>
    import FirmConfigurableDocumentsForm from '@desktop/components/FirmConfigurableDocumentsForm.vue';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';

    export default {
        name: 'FirmConfigurableDocuments',
        components: {
            'csp-desktop-firm-configurable-documents-form': FirmConfigurableDocumentsForm,
        },
        mixins: [FormDataMixin],
        props: {
            cols: {
                type: Number,
                default: 12,
            },
            // If of context with type defined below
            contextId: {
                type: Number,
                required: true,
            },
            // Type must be one of [firm|firmGroup|firmAssociation|reseller]
            contextType: {
                type: String,
                required: true,
            },
        },
    }
</script>
